import React from 'react'
import I18n from 'lib/i18n'

export default function slideOne ({ slideIndex }) {
  return (
    <div className='slide.slide-1' style={{ display: slideIndex === 1 ? 'block' : 'none' }}>
      <div className='left-part'>
        <h3 dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_1_title') }} />
        <div className='only-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto', marginBottom: 10 }}>
          <img
            className='drop-shadow retina lazyload'
            data-src='/assets/pages/how1/find.png'
            data-retina='/assets/pages/how1/find@2x.png'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_1') }} />
      </div>
      <div className='right-part not-responsive'>
        <div className='not-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto' }}>
          <img
            alt=''
            className='drop-shadow retina lazyload'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            data-src='/assets/pages/how1/find.png'
            data-retina='/assets/pages/how1/find@2x.png'
          />
        </div>
      </div>
    </div>
  )
}
